import React, { useState } from 'react';

import ShowLivePublic from "./ShowLivePublic";
import ShowLivePrivate from "./ShowLivePrivate";
import { useTranslation } from "../../context/TranslationContext"; 
import SectionTabs from "../../component/SectionTabs";

export default function Live() {
  const [selectedSection, setSelectedSection] = useState("showlivepublic");
  const { translations, language } = useTranslation(); 
  const isArabic = language === "ar";

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedSection(value);
  };

  const sections = {
    showlivepublic: {
      label: translations.ShowLivePublic,
    },
    showliveprivate: {
      label: translations.ShowLivePrivate,
    },
  };

  return (
    <div className={`flex ${isArabic ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row-reverse '} pt-24 w-full`}>
      <div
        className="flex-1"
        style={{
          fontFamily: "Tajwal, sans-serif",
          direction: isArabic ? "rtl" : "ltr",
          textAlign: isArabic ? "right" : "left",
        }}
      >
        <h2 className="text-xl font-bold mb-1">{translations.liveLecturesTitle}</h2>
        <h4 className="text-l font-bold text-gray-500 mb-4">
          {translations.liveLecturesSubtitle}
        </h4>

        {/* قائمة منسدلة للأجهزة الصغيرة */}
        <SectionTabs
          sections={sections}
          selectedSection={selectedSection}
          onChange={handleSelectChange}
        />

        {/* أزرار للأجهزة الكبيرة */}
        <div className="hidden sm:flex flex-wrap justify-center md:justify-start gap-2 mt-4">
          <button
            className={`flex items-center px-4 py-2 rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
              selectedSection === "showlivepublic" ? "bg-primary-blue text-white" : "bg-blue"
            }`}
            onClick={() => setSelectedSection("showlivepublic")}
          >
            {translations.ShowLivePublic}
          </button>
          <button
            className={`flex items-center px-4 py-2 rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
              selectedSection === "showliveprivate" ? "bg-primary-blue text-white" : "bg-blue"
            }`}
            onClick={() => setSelectedSection("showliveprivate")}
          >
            {translations.ShowLivePrivate}
          </button>
        </div>

        <hr className="my-2 border-gray-200 mb-10" />

        {/* محتوى كل قسم */}
        {selectedSection === "showlivepublic" && <ShowLivePublic />}
        {selectedSection === "showliveprivate" && <ShowLivePrivate />}
      </div>
    </div>
  );
}
